import React, { memo, useState, useContext, useRef, useEffect } from 'react'
import {
  Button,
  DropdownMenu,
  HeadingText,
  TextInput,
  CaptionText,
  Alert,
  DateInput,
  MaskedTextInput,
  Link,
} from '@paypalcorp/pp-react'
import {
  Message,
  Context as WorldReadyContext,
} from '@paypalcorp/worldready-react'
import { MessageFormat } from '@paypalcorp/worldready'
import ReCAPTCHA from 'react-google-recaptcha'
import Spinner from '../../../screens/dsr/common/dsr-spinner'
import asASlide from '../../common/as-a-slide'
import {
  getFeatureValue,
  isEmail,
  isEmptyOrWhiteSpace,
  serverData,
  fptiCustomClick,
  fptiCustomImpression,
} from '../../../utils'
import { post } from '../../../utils/ajax.js'
import { LOGGEDOUT_CREATE_CASE_API } from '../../../constants/constants'
import DATAPRIVACY_FPTI from '../../../config/data-privacy-fpti'
const loggedOutFPTI = DATAPRIVACY_FPTI.LOGGED_OUT

const dsrRecaptchaKey = getFeatureValue('dsrRecaptchaSiteKey')
const recaptchaFlag = getFeatureValue('recaptchaFlagToDisplay')

const closedsecurityOptions = [
  {
    primaryText: <Message id="dsrLoggedout.darform.bank4digit" />,
    value: 'BANK_ACCOUNT_NUMBER',
  },
  {
    primaryText: <Message id="dsrLoggedout.darform.card4digit" />,
    value: 'CARD_NUMBER',
  },
  {
    primaryText: <Message id="dsrLoggedout.darform.zipcodelabel" />,
    value: 'ZIPCODE',
  },
  {
    primaryText: <Message id="dsrLoggedout.darform.dob" />,
    value: 'DOB',
  },
]

const guestIdentityOption = [
  {
    primaryText: <Message id="dsrLoggedout.darform.zipcodelabel" />,
    value: 'ZIPCODE',
  },
  {
    primaryText: <Message id="dsrLoggedout.darform.addressline1" />,
    value: 'ADDRESS_LINE1',
  },
]

const guestSecurityOption = [
  {
    primaryText: <Message id="dsrLoggedout.darform.banknumber" />,
    value: 'BANK_ACCOUNT_NUMBER',
  },
  {
    primaryText: <Message id="dsrLoggedout.darform.cardnumber" />,
    value: 'CARD_NUMBER',
  },
]

const optionsToFile = [
  {
    primaryText: <Message id="dsrLoggedout.darform.file.pdf" />,
    value: 'PDF',
  },
  {
    primaryText: <Message id="dsrLoggedout.darform.file.json" />,
    value: 'JSON',
  },
]

const closedAccountOptionsTodelete = {
  BANK_ACCOUNT_NUMBER: '',
  CARD_NUMBER: '',
  ZIPCODE: '',
  DOB: '',
}

const guestAccountOptionsTodelete = {
  ZIPCODE: '',
  ADDRESS_LINE1: '',
}

const guestAccountSecurityOptionsTodelete = {
  BANK_ACCOUNT_NUMBER: '',
  CARD_NUMBER: '',
}

// eslint-disable-next-line complexity
const LoggedOutDsrForm = memo((props) => {
  const worldReady = useContext(WorldReadyContext)
  const [impressionDone, setImpressionDone] = useState(false)
  const [selectedFileItem, setSelectedFileItem] = useState('PDF')
  const [selectedSecurityItem, setselectedSecurityItem] = useState(
    'BANK_ACCOUNT_NUMBER',
  )
  const [selectedGuestSecurityItem, setselectedGuestSecurityItem] = useState(
    'BANK_ACCOUNT_NUMBER',
  )
  const [selectedGuestIdentityItem, setselectedGuestIdentityItem] =
    useState('ZIPCODE')

  const [showAlert, setShowAlert] = useState(false)
  const [showSpinner, setShowSpinner] = useState(false)
  const [formValues, setFormValues] = useState(null)
  const [errfieldObj, setErrfieldObj] = useState(null)

  const {
    onModalNavigate,
    modalParams: { radiovalue = '' } = {},
    updateModalStore,
  } = props

  let userObj = {
    filetype: 'PDF',
    fname: '',
    lname: '',
    email: '',
    captchaToken: '',
  }

  const errorObj = {}

  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomImpression(loggedOutFPTI.CREATE_DATA_REQUEST_IMPRESSION)
    }

    if (radiovalue === 'closedaccountdata') {
      userObj = {
        ...userObj,
        security: 'BANK_ACCOUNT_NUMBER',
        BANK_ACCOUNT_NUMBER: '',
        type: 'CLOSED',
      }
    } else {
      userObj = {
        ...userObj,
        security: 'BANK_ACCOUNT_NUMBER',
        BANK_ACCOUNT_NUMBER: '',
        identity: 'ZIPCODE',
        ZIPCODE: '',
        type: 'GUEST',
      }
    }

    for (const i in userObj) {
      errorObj[i] = false
    }
    setFormValues({ ...userObj })
    setErrfieldObj({ ...errorObj })
  }, [])

  const recaptchaRef = useRef(null)
  window.recaptchaOptions = {
    useRecaptchaNet: true,
  }

  const handleSelection = (date) => {
    formValues.DOB = ''
    if (date) {
      const sDate = date.getDate().toString().padStart(2, '0')
      const sMonth = (date.getMonth() + 1).toString().padStart(2, '0')
      const sYear = date.getFullYear()

      const age18 = new Date()
      age18.setFullYear(age18.getFullYear() - 18)
      if (!(date > age18)) {
        formValues.DOB = sYear + '-' + sMonth + '-' + sDate
      }
    }
  }

  const validateFields = () => {
    for (const i in errfieldObj) {
      errfieldObj[i] = isEmptyOrWhiteSpace(formValues[i])
    }
    const isvalidEmail = isEmail(formValues.email)
    errfieldObj.email = isvalidEmail
    setErrfieldObj({ errfieldObj, ...errfieldObj })
  }

  async function postDARRequest(reqparams) {
    let fptiData = loggedOutFPTI.CREATE_DATE_REQUEST_BTN
    fptiData = {
      ...fptiData,
      page_type: radiovalue,
    }
    fptiCustomClick(fptiData)

    setShowSpinner(true)
    const response = await post(LOGGEDOUT_CREATE_CASE_API, reqparams)

    if (response && response.success) {
      setShowSpinner(false)
      setShowAlert(false)
      updateModalStore({ email: formValues.email })
      onModalNavigate(2)
    } else {
      setShowSpinner(false)
      setShowAlert(true)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (recaptchaFlag) {
      const ctoken = recaptchaRef.current.getValue()
      formValues.captchaToken = ctoken
    } else {
      formValues.captchaToken = 'testvalue'
    }

    validateFields()
    const isValid = Object.keys(formValues).some(
      (item) => formValues[item] === '',
    )

    if (!isValid) {
      const reqparams = {
        _csrf: serverData._csrf,
        fields: JSON.stringify(formValues),
      }
      postDARRequest(reqparams)
    }
  }

  const handleFileSelection = (event) => {
    formValues.filetype = event.target.value
    setSelectedFileItem(event.target.value)
  }

  const bankCardValidation = (value, name) => {
    formValues[name] = value
    setFormValues({ ...formValues, [name]: value })
  }

  const handlesecuritySelection = (event, objname, keyname) => {
    for (const i in objname) {
      delete formValues[i]
      delete errfieldObj[i]
    }
    const newUserObj = {
      ...formValues,
      [keyname]: event.target.value,
      [event.target.value]: '',
    }
    const newErrObj = {
      ...errfieldObj,
      [event.target.value]: false,
    }
    setFormValues({ ...newUserObj })
    setErrfieldObj({ ...newErrObj })
  }

  const handleChange = (evt) => {
    formValues[evt.target.name] = evt.target.value
    const newErrObj = {
      ...errfieldObj,
      [evt.target.name]: false,
    }
    setErrfieldObj({ ...newErrObj })
  }

  const getDropdownLable = (msgId) => {
    return new MessageFormat(worldReady, {
      id: msgId,
    }).format()
  }

  const maskOptions = {
    mask: 'y-m-d',
  }

  const parseDate = (str) => {
    if (!str) {
      return null
    }
    const parts = str.split('-')
    return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]))
  }

  return (
    <>
      {showSpinner && <Spinner />}
      {!showSpinner && (
        <>
          <HeadingText
            id="darform-header"
            size="sm"
            className="text-center requestForm-row"
          >
            <Message id="dsrLoggedout.darform.header" />
          </HeadingText>

          <section className="page-body-container requestForm-row">
            <div className="inner-container">
              {errfieldObj && (
                <section className="data-request-page requestForm-section-row">
                  <form className="formcontainer">
                    {showAlert && (
                      <Alert
                        className="requestForm-row"
                        type="error"
                        closeButton={{
                          onClick: () => {
                            setShowAlert(false)
                          },
                        }}
                      >
                        <Message id="dar.header.alert.fail" />
                      </Alert>
                    )}

                    <div className="requestForm-row">
                      <DropdownMenu
                        name="filetype"
                        label={getDropdownLable(
                          'dsrLoggedout.darform.dd.choosefile',
                        )}
                        options={optionsToFile}
                        onChange={handleFileSelection}
                        value={selectedFileItem}
                      />
                    </div>

                    <div className="requestForm-row">
                      <TextInput
                        name="fname"
                        label={<Message id="dsrLoggedout.darform.fnlabel" />}
                        defaultValue={formValues.fname}
                        onChange={handleChange}
                        errorText={
                          errfieldObj.fname ? (
                            <Message id="dsrLoggedout.darform.fn.validation.required" />
                          ) : (
                            ''
                          )
                        }
                      />
                    </div>
                    <div className="requestForm-row">
                      <TextInput
                        name="lname"
                        label={<Message id="dsrLoggedout.darform.lnlabel" />}
                        defaultValue={formValues && formValues.lname}
                        onChange={handleChange}
                        errorText={
                          errfieldObj.lname ? (
                            <Message id="dsrLoggedout.darform.ln.validation.required" />
                          ) : (
                            ''
                          )
                        }
                      />
                    </div>
                    <div className="requestForm-row">
                      <TextInput
                        name="email"
                        label={
                          <Message id="dsrLoggedout.darform.email.label" />
                        }
                        helperText={
                          radiovalue === 'closedaccountdata' ? (
                            <Message id="dsrLoggedout.darform.closedaccountoption" />
                          ) : (
                            ''
                          )
                        }
                        onChange={handleChange}
                        defaultValue={formValues && formValues.email}
                        errorText={
                          errfieldObj.email ? (
                            <Message id="dsrLoggedout.darform.email.validation.required" />
                          ) : (
                            ''
                          )
                        }
                      />
                    </div>

                    {radiovalue === 'closedaccountdata' && (
                      <>
                        <div className="requestForm-row">
                          <DropdownMenu
                            name="security"
                            label={getDropdownLable(
                              'dsrLoggedout.darform.identitylabel',
                            )}
                            options={closedsecurityOptions}
                            onChange={(event) => {
                              handlesecuritySelection(
                                event,
                                closedAccountOptionsTodelete,
                                'security',
                              )
                              setselectedSecurityItem(event.target.value)
                            }}
                            value={selectedSecurityItem}
                          />
                        </div>

                        {selectedSecurityItem === 'BANK_ACCOUNT_NUMBER' && (
                          <div className="requestForm-row">
                            <MaskedTextInput
                              name="BANK_ACCOUNT_NUMBER"
                              label={
                                <Message id="dsrLoggedout.darform.banknumber" />
                              }
                              maskOptions={{
                                mask: '0000',
                              }}
                              onAccept={(value) => {
                                bankCardValidation(value, 'BANK_ACCOUNT_NUMBER')
                              }}
                              errorText={
                                errfieldObj.BANK_ACCOUNT_NUMBER ? (
                                  <Message id="dsrLoggedout.darform.banknumberfield.required" />
                                ) : (
                                  ''
                                )
                              }
                            />
                          </div>
                        )}

                        {selectedSecurityItem === 'CARD_NUMBER' && (
                          <div className="requestForm-row">
                            <MaskedTextInput
                              name="CARD_NUMBER"
                              label={
                                <Message id="dsrLoggedout.darform.cardnumber" />
                              }
                              maskOptions={{
                                mask: '0000',
                              }}
                              onAccept={(value) => {
                                bankCardValidation(value, 'CARD_NUMBER')
                              }}
                              errorText={
                                errfieldObj.CARD_NUMBER ? (
                                  <Message id="dsrLoggedout.darform.cardnumberfield.required" />
                                ) : (
                                  ''
                                )
                              }
                            />
                          </div>
                        )}

                        {selectedSecurityItem === 'ZIPCODE' && (
                          <div className="requestForm-row">
                            <TextInput
                              name="ZIPCODE"
                              label={
                                <Message id="dsrLoggedout.darform.zipcodelabel" />
                              }
                              defaultValue={formValues.ZIPCODE}
                              onChange={handleChange}
                              errorText={
                                errfieldObj.ZIPCODE ? (
                                  <Message id="dsrLoggedout.darform.zipcode.validation" />
                                ) : (
                                  ''
                                )
                              }
                            />
                          </div>
                        )}

                        {selectedSecurityItem === 'DOB' && (
                          <div className="requestForm-row">
                            <DateInput
                              name="dateSelector"
                              label={<Message id="dsrLoggedout.darform.dob" />}
                              onSelection={handleSelection}
                              maskOptions={maskOptions}
                              parseDate={parseDate}
                              errorText={
                                errfieldObj.DOB ? (
                                  <Message id="dsrLoggedout.darform.doblabel.validation" />
                                ) : (
                                  ''
                                )
                              }
                            />
                          </div>
                        )}
                      </>
                    )}

                    {radiovalue === 'guestdata' && (
                      <>
                        <div className="requestForm-row">
                          <DropdownMenu
                            name="security"
                            label={getDropdownLable(
                              'dsrLoggedout.darform.securitylabel',
                            )}
                            options={guestSecurityOption}
                            onChange={(event) => {
                              handlesecuritySelection(
                                event,
                                guestAccountSecurityOptionsTodelete,
                                'security',
                              )
                              setselectedGuestSecurityItem(event.target.value)
                            }}
                            value={selectedGuestSecurityItem}
                          />
                        </div>

                        {selectedGuestSecurityItem ===
                          'BANK_ACCOUNT_NUMBER' && (
                          <div className="requestForm-row">
                            <MaskedTextInput
                              name="BANK_ACCOUNT_NUMBER"
                              label={
                                <Message id="dsrLoggedout.darform.banknumber" />
                              }
                              maskOptions={{
                                mask: '00000000000000000000',
                              }}
                              onAccept={(value) => {
                                bankCardValidation(value, 'BANK_ACCOUNT_NUMBER')
                              }}
                              errorText={
                                errfieldObj.BANK_ACCOUNT_NUMBER ? (
                                  <Message id="dsrLoggedout.darform.banknumberfield.required" />
                                ) : (
                                  ''
                                )
                              }
                            />
                          </div>
                        )}

                        {selectedGuestSecurityItem === 'CARD_NUMBER' && (
                          <div className="requestForm-row">
                            <MaskedTextInput
                              name="CARD_NUMBER"
                              label={
                                <Message id="dsrLoggedout.darform.cardnumber" />
                              }
                              maskOptions={{
                                mask: '00000000000000000000',
                              }}
                              onAccept={(value) => {
                                bankCardValidation(value, 'CARD_NUMBER')
                              }}
                              errorText={
                                errfieldObj.CARD_NUMBER ? (
                                  <Message id="dsrLoggedout.darform.cardnumberfield.required" />
                                ) : (
                                  ''
                                )
                              }
                            />
                          </div>
                        )}

                        <div className="requestForm-row">
                          <DropdownMenu
                            name="identity"
                            label={getDropdownLable(
                              'dsrLoggedout.darform.identitylabel',
                            )}
                            options={guestIdentityOption}
                            onChange={(event) => {
                              handlesecuritySelection(
                                event,
                                guestAccountOptionsTodelete,
                                'identity',
                              )
                              setselectedGuestIdentityItem(event.target.value)
                            }}
                            value={selectedGuestIdentityItem}
                          />
                        </div>

                        {selectedGuestIdentityItem === 'ZIPCODE' && (
                          <div className="requestForm-row">
                            <TextInput
                              name="ZIPCODE"
                              label={
                                <Message id="dsrLoggedout.darform.zipcodelabel" />
                              }
                              defaultValue={formValues.ZIPCODE}
                              onChange={handleChange}
                              errorText={
                                errfieldObj.ZIPCODE ? (
                                  <Message id="dsrLoggedout.darform.zipcode.validation" />
                                ) : (
                                  ''
                                )
                              }
                            />
                          </div>
                        )}

                        {selectedGuestIdentityItem === 'ADDRESS_LINE1' && (
                          <div className="requestForm-row">
                            <TextInput
                              name="ADDRESS_LINE1"
                              label={
                                <Message id="dsrLoggedout.darform.addressline1" />
                              }
                              defaultValue={formValues.ADDRESS_LINE1}
                              onChange={handleChange}
                              errorText={
                                errfieldObj.ADDRESS_LINE1 ? (
                                  <Message id="dsrLoggedout.darform.address.validation" />
                                ) : (
                                  ''
                                )
                              }
                            />
                          </div>
                        )}
                      </>
                    )}

                    {recaptchaFlag && (
                      <div className="captcha-center requestForm-row">
                        <div>
                          <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey={dsrRecaptchaKey.sitekey || ''}
                          />

                          {errfieldObj.captchaToken ? (
                            <div className="customError">
                              <Alert type="error" className="errorText">
                                <Message id="dsrLoggedout.darform.captcha.required" />
                              </Alert>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    )}

                    <div className="text-center requestForm-row">
                      <Button id="submitbtn" onClick={handleSubmit}>
                        <Message id="dsrLoggedout.darform.submitbtn" />
                      </Button>
                    </div>
                  </form>
                  <div className="requestForm-row">
                    <CaptionText className="text-center">
                      <Message
                        id="dsrLoggedout.clicksubmitbtn"
                        link={(innerMessage) => (
                          <Link
                            href={`https://${serverData.cdnPayPalDomain}/en/webapps/mpp/ua/privacy-full#3`}
                            id="privacy_statment_link"
                          >
                            {innerMessage}
                          </Link>
                        )}
                      />
                    </CaptionText>
                  </div>
                </section>
              )}
            </div>
          </section>
        </>
      )}
    </>
  )
})
LoggedOutDsrForm.displayName = 'LoggedOutDsrForm'
export default asASlide({ position: 1 })(LoggedOutDsrForm)
